import { FormItemBase } from './form-item-base';

export class FormItemDropdown extends FormItemBase<string> {
  controlType = 'dropdown';
  options: {key: string, value: string}[] = [];
  optionVals: any;
  optionStrs: any;

  constructor(options: {
    itemType?: string,
    value?: string,
    key?: string,
    label?: string,
    shortlabel?: string,
    altlabel?: string,
    comment?: string,
    required?: boolean,
    order?: number,
    controlType?: string,
    depth?: number,
    isVisible?: boolean,
    isEnabled?: boolean,
    isReadOnly?: boolean,
    invalidValue?: boolean,
    useAltText?: boolean,
    sizeHint?: string,
    weightHint?: string,
    tooltipBody?: string,
    tooltipLink?: string,
    tooltipImage?: string,
    isTooltipDefined?: boolean,
    optionStrs?: any,
    optionVals?: any,
    errorHint?: string
  } = {}) {
    super(options);
    const key = 'options';
    this.isReadOnly = options.isReadOnly;
    this.optionStrs = options.optionStrs;
    this.optionVals = options.optionVals;
  
    this.labelClass = 'dx-field-label field-label-override form-item-dropdown-label form-item-depth-' + this.depth.toString();
  }
}
